import * as React from 'react';
import { withStyles, StyleRulesCallback, WithStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import { translation } from '../../i18n';
import { TextField } from '@material-ui/core';
import { IObservableValue, observable } from 'mobx';
import { emptyQuestionRequest, QuestionRequest, QuestionType } from '../questionTypes';
import { Typography } from '@material-ui/core';
import { List } from '@material-ui/core';
import { ListItem } from '@material-ui/core';
import { ListItemText } from '@material-ui/core';
import { ListItemSecondaryAction } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { Add as AddIcon } from '@material-ui/icons';
import { Cancel as CancelIcon } from '@material-ui/icons';
import { Save as SaveIcon } from '@material-ui/icons';
import { createPicker } from '../../util/picker';
import { emptyValidationErrors, isValidationErrors, ValidationErrors } from '../../api/restApi';
import { renderRemainingErrors } from '../../util/formUtils';
import { isValidMultipleColumnQuestion } from '../../util/validations';
import { ColumnRequest } from '../columnTypes';
import { NewColumnDialog } from './NewColumnDialog';
import { createQuestion } from './questionCatalogueApi';
import { Spinner } from '../../spinner/Spinner';
import SaveSnackBar from '../../components/SaveSnackBar';
import { Fab } from '@material-ui/core';

interface Props {
  renderSearch: (showSearch: boolean) => void;
}

type LocalStyles = 'button' | 'previewArea';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  button: {
    margin: theme.spacing.unit,
    right: theme.spacing.unit * 2,
    bottom: theme.spacing.unit * 2,
    position: 'fixed'
  },
  previewArea: {
    padding: theme.spacing.unit * 2,
  },
});

type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class CreateMultipleColumnQuestion extends React.Component<PropsWithStyle, {}> {

  @observable private newQuestion: QuestionRequest = emptyQuestionRequest();
  @observable private selectedColumns: ColumnRequest[] = [];
  @observable private validationErrors: ValidationErrors = emptyValidationErrors();
  private open: IObservableValue<boolean> = observable.box(false);
  private displaySnackbar: IObservableValue<boolean> = observable.box(false);
  private saveLoading: IObservableValue<boolean> = observable.box(false);


  constructor(props: PropsWithStyle) {
    super(props);
    this.props.renderSearch(false);
    this.setQuestionType = this.setQuestionType.bind(this);
    this.dialogOnSave = this.dialogOnSave.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onSave = this.onSave.bind(this);

    this.newQuestion.questionType = QuestionType.MULTIPLE_COLUMNS;
  }


  public render() {
    const errorPicker = createPicker(this.validationErrors.fieldErrors);
    return (
      <>
        {this.saveLoading.get() ?
          <Spinner/> :
          <>
            <div style={{width: '100%', textAlign: 'right'}}>
              <div>
                <Button onClick={this.onSave}><SaveIcon/> {translation.t('actions.save')}</Button>
              </div>
            </div>
            <TextField
              label={translation.t('question.this')}
              fullWidth={true}
              value={this.newQuestion.question}
              onChange={ev => this.newQuestion.question = ev.target.value}
            />
            <TextField
              label={translation.t('module.description')}
              multiline={true}
              fullWidth={true}
              value={this.newQuestion.description}
              onChange={ev => {
                this.newQuestion.description = ev.target.value
              }}
            />
            <Typography variant={'subtitle1'}>{translation.t('question.column')}:</Typography>
            {
              this.selectedColumns.length === 0 ?
                <>
                  <Typography>{translation.t('createCatalogueComponent.noColumnsSelected')}</Typography>
                  {renderRemainingErrors(errorPicker.pick(e => e.field === 'columns'))}
                </>
                :
                <List>
                  {this.selectedColumns.map((column, index) => (
                    <ListItem
                      key={index + 'column'}
                      button={false}
                    >
                      <ListItemText primary={column.title}/>
                      <ListItemSecondaryAction>
                        <Button onClick={() => this.selectedColumns.splice(this.selectedColumns.indexOf(column), 1)}>
                          <CancelIcon/>
                        </Button>
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                </List>
            }
            {renderRemainingErrors(errorPicker.remaining())}
            <Fab color="primary" arial-label="Add" className={this.props.classes.button} onClick={() => this.open.set(true)}>
              <AddIcon/>
            </Fab>
            <NewColumnDialog onClose={this.onClose} onSave={this.dialogOnSave} open={this.open.get()}/>
            <SaveSnackBar onClose={() => this.displaySnackbar.set(false)} open={this.displaySnackbar.get()}
                          massage={translation.t('questionTab.saved')}/>
          </>
        }
      </>

    );
  }

  private onClose() {
    this.open.set(false);
  }

  private dialogOnSave(column: ColumnRequest) {
    this.open.set(false);
    this.onClose();
    this.selectedColumns.push(column);
  }

  private setQuestionType(event: any) {
    const type = event.target.value;
    if (QuestionType.MULTIPLE_CHOICE.toString() === type) {
      this.newQuestion.questionType = QuestionType.MULTIPLE_CHOICE
    }
    else if (QuestionType.MULTIPLE_COLUMNS.toString() === type) {
      this.newQuestion.questionType = QuestionType.MULTIPLE_COLUMNS
    }
    else {
      this.newQuestion.questionType = QuestionType.TEXT
    }
  }

  private onSave() {
    this.newQuestion.columns = this.selectedColumns;
    this.validationErrors = isValidMultipleColumnQuestion(this.newQuestion);
    if (this.validationErrors === undefined || this.validationErrors.fieldErrors.length === 0) {
      this.saveLoading.set(true);
      createQuestion(this.newQuestion).then(
        data => {
          this.saveLoading.set(false);
          if (isValidationErrors(data)) {
            this.validationErrors = data;
          } else {
            this.validationErrors = emptyValidationErrors();
            this.displaySnackbar.set(true);
            this.newQuestion.question = '';
            this.newQuestion.description = '';
            this.newQuestion.enableComment = false;
            this.newQuestion.columns = [];
            this.selectedColumns = [];
          }
        }
      )
    }
  }
}

export default withStyles(localStyles)(CreateMultipleColumnQuestion);
